<template>
  <b-modal id="modal-item" size="lg" title="Informasi Barang">
    <b-row>
      <b-col cols="12" class="text-center mb-2">
        <UploadPhoto v-if="!photo_url" :label-for="'upload_photo'"
          :style-name="'width:140px;height:140px;margin: 0 auto;'" :photo-url-parent="photo_url" @photo="getPhoto" />
        <div v-else>
          <div class="box__upload--photo mx-auto" :style="`background-image: url(${photo_url});`"
            @click="photo_url = ''">
            <b-avatar class="floating__close--button">
              <feather-icon class="text-danger" icon="XIcon" />
            </b-avatar>
          </div>
        </div>
      </b-col>
      <!-- Nama Barang -->
      <b-col cols="12" md="12" class="mb-2 custom__form--input">
        <label for="v-nama-barang">Nama Barang <span class="text-danger">*</span></label>
        <b-form-group>
          <b-form-input id="v-nama-barang" v-model="formPayload.name" type="text" placeholder="Nama Barang"
            class="custom__input" />
        </b-form-group>
      </b-col>
      <!-- Deskripsi Barang -->
      <b-col cols="12" md="12" class="mb-3 custom__form--input">
        <label for="v-deskripsi">Deskripsi Barang</label>
        <b-form-group>
          <b-form-textarea id="v-deskripsi" v-model="formPayload.description" rows="5" placeholder="Deskripsi Barang"
            class="custom__textarea" />
        </b-form-group>
        <b-card class="px-33 py-1 mt-3" style="background:#FFF4EC;border-radius:8px;" no-body>
          <div class="d-flex align-items-center">
            <div>
              <div style="width:30px;height:30px;background: #FF8F39;opacity:0.75;border-radius:50%;" />
            </div>
            <span class="text-dark fw-bold-500 size14 ml-1">
              Informasi disini merupakan penjelasan secara umum, atau peruntukan suatu barang, tidak menjelaskan
              spesifik sku dan merk tertentu.
            </span>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <template #modal-footer="{}">
      <b-button variant="primary" @click="editUuid == null ? createItem() : updateItem()">
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import {
  BModal, BContainer, BRow, BCol, BButton, BFormGroup, BFormInput, BFormTextarea, BCard, BAvatar
} from 'bootstrap-vue'

import UploadPhoto from '@/components/UploadPhoto.vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BContainer,
    BCard,
    UploadPhoto,
    BAvatar
  },
  props: {
    formData: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: '',
    },
    createItem: {
      type: Function,
    },
    editItem: {
      type: Function,
    },
    editId: {
      type: String,
    },
    updateItem: {
      type: Function,
    },
    cleanUpForm: {
      type: Function,
    },
    iconBank: {
      type: String,
    },
  },
  watch: {
    iconBank(value) {
      this.photo_url = value
    },
    editId(value) {
      this.editUuid = value
    },
    formData(value) {
      this.formPayload = value
    },
    formPayload: {
      handler(value) {
        this.$emit('getPayload', value)
      },
      deep: true,
    },
  },
  data() {
    return {
      formPayload: {
        name: '',
        description: '',
        logo: '',
      },
      photo_url: '',
      editUuid: null,
    }
  },
  methods: {
    getPhoto(value) {
      this.formPayload.logo = value.photo
    },
    directPage() {
      this.cleanUpForm()
      this.$bvModal.hide('modal-item')
    },
  },
}
</script>

<style lang="scss" scoped>
.box__upload--photo {

  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #EFF1F5;
  border: 1px dashed #7A7F94;
  border-radius: 8px;
  position: relative;

  background-repeat: no-repeat;
  background-size: cover;
  object-fit: cover;

  width: 140px;
  height: 140px;

  .floating__close--button {
    position: absolute;
    top: 6px;
    width: 24px;
    height: 24px;
    right: 6px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';
</style>
